/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import { API_TYPE, IApi } from '@umu/umu-fetch';
import { IUnclearKeyObj } from '@umu/umu-types';
import { AuthAPI } from './go/auth';
import { ReportAPI } from './go/report';
import { QuestionCollectionAPI } from './megrez/exam/questionCollection';
import { NodejsExamAPI } from './nodejs/exam';
import { PrivateMessageAPI } from './nodejs/privateMessage';
import { EnterpriseAPI } from './enterprise';
import { PaymentAPI } from './payment';
import { CategoryAPI } from './category';
import { DepartmentAPI } from './department';
import { MarketAPI } from './market';
import { ProfileAPI } from './profile';
import { SearchAPI } from './search';
import { SubTitleAPI } from './subtitle';
import { HomeworkAPI } from './homework';
import { GrowthApi } from './growth';
import { CourseAPI } from './course';
import { UShowApi } from './uShow';
const BASE_PATH = '/api';

/**
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 * {@link https://docs.google.com/document/d/1mNWtj9AFzyaXG_K13jsYWdmxi4wpxrhQAGYqDJUcmDo/edit#heading=h.klndeohyu0zy}
 */

/**
 * @see http://api.umucdn.cn/project/106/wiki
 */
const v1 = '/uapi/v1';
const v2 = '/uapi/v2';

const POLL_API = `${v1}/poll`;

/**
 * 1- @see http://api.umucdn.cn/project/111/interface/api/1199
 */
const COURSE_API = `${v1}/course`;

const CommonApi: IUnclearKeyObj<IApi> = {
    // 页面pv统计
    VIEW_LOG: {
        url: '/uapi/v1/stat/view-log',
        type: API_TYPE.GET,
    },

    USER_LOGOUT: {
        url: '/passport/account/logout',
        type: API_TYPE.GET,
    },

    GET_ENTERPRISE_CONFIG: {
        url: '/napi/config/enterprise',
        type: API_TYPE.GET,
    },
    GET_AI_AUDIO_SLIDES_OPTIONS: {
        url: '/napi/ai-audio-slides/options',
        type: API_TYPE.GET,
    },

    /**
     * 考试排行榜图片
     * https://docs.google.com/document/d/1NYTZvbsIO4uzf1HBQsNbxKfL1094hJmH2EGdpTWQrZ0/edit#heading=h.2dntcu809kep
     */
    QUIZ_RANKING_SHARE_PIC: {
        url: `${BASE_PATH}/exam/getexamrankingsharepic`,
        type: API_TYPE.GET,
    },

    /**
     * 考试排行榜列表
     * https://docs.google.com/document/d/1NYTZvbsIO4uzf1HBQsNbxKfL1094hJmH2EGdpTWQrZ0/edit#heading=h.2dntcu809kep
     */
    QUIZ_RANKING_LIST: {
        url: `${BASE_PATH}/exam/getexamrankinglist`,
        type: API_TYPE.GET,
    },

    // 我的学习任务
    MY_ASSIGNMENT_LIST: {
        url: `${BASE_PATH}/task/myassignmentlist`,
        type: API_TYPE.GET,
    },

    NEW_QUIZ_RANKING_LIST: {
        url: `/megrez/exam/v1/getExamRankingList`,
        type: API_TYPE.GET,
    },

    GROUP_REPORTLIST: {
        url: '/api/group/reportlist',
        type: API_TYPE.GET,
    },

    // 课程大数据分享
    GROUP_SHAREREPORT: {
        url: '/api/share/getreportsharepic',
        type: API_TYPE.GET,
    },
    // 教师签名
    GROUP_SIGNATURE: {
        url: '/api/user/getteachersignaturepic',
        type: API_TYPE.GET,
    },
    // 学习证书图片
    GROUP_CERTIFICATE: {
        url: '/api/share/getcertificatesharepic',
        type: API_TYPE.GET,
    },
    // 学习证书列表
    GROUP_CERTIFICATELIST: {
        url: '/api/group/certificatelist',
        type: API_TYPE.GET,
    },

    /**
     * 直播库查、列表接口
     * https://docs.google.com/document/d/1zo3B-GUHp2ProH3oYIZw9GXnTFaAJ6vC0g0PsRUdVaA/edit#heading=h.cx2cxzvnbe43
     */
    // 直播预约
    LIVESUB_CIRBE: {
        url: `/uapi/v1/live/subscribe`,
        type: API_TYPE.POST,
    },

    LIVE_RESOURCE_PUBLISH: {
        url: `/uapi/v1/live/publish-resource-update`,
        type: API_TYPE.POST,
    },

    LISTENER_INFO_FETCH: {
        url: '/ajax/getWeikeListenerInfo',
        type: API_TYPE.GET,
    },

    MAKE_DOC_READ_SPEED_STATUS_OLD: {
        url: '/ajax/markWeikePlayStatus',
        type: API_TYPE.POST,
    },

    // 获取element统计信息
    GET_ELEMENT_INFO: {
        url: '/uapi/v1/element',
        type: API_TYPE.GET,
    },

    // 获取element统计信息
    GET_ELEMENT_STAT: {
        url: '/uapi/v1/element/stat',
        type: API_TYPE.GET,
    },

    // 获取element 正在听、已听完用户列表
    GET_ELEMENT_LISTENED: {
        url: '/uapi/v1/element/listened',
        type: API_TYPE.GET,
    },

    GET_ELEMENT_LISTENING: {
        url: '/uapi/v1/element/listening',
        type: API_TYPE.GET,
    },

    SAVE_ELEMENT: {
        url: '/uapi/v1/element/save',
        type: API_TYPE.POST,
    },
    SAVE_SESSION: {
        url: '/api/session/savesession',
        type: API_TYPE.POST,
    },
    ELEMENT_BIND_CHAPTER: {
        url: '/uapi/v1/session/bind-chapter',
        type: API_TYPE.POST,
    },

    GET_ELEMENT_LIST: {
        url: '/uapi/v1/element/list',
        type: API_TYPE.GET,
    },
    GET_RESOURCE_BY_MULTI_OBJ: {
        url: '/uapi/v1/resource/list-by-multi-obj',
        type: API_TYPE.GET,
    },

    // 关注/取消关注
    ADD_FLLOW: {
        url: '/ajax/follow/add',
        type: API_TYPE.POST,
    },

    DELETE_FLLOW: {
        url: '/ajax/follow/delete',
        type: API_TYPE.POST,
    },

    // 获取讲稿列表
    LIVE_GET_RESOURCES: {
        url: '/uapi/v1/live/resources',
        type: API_TYPE.GET,
    },

    // 保存讲稿列表
    LIVE_SAVE_RESOURCES: {
        url: '/uapi/v1/live/resources',
        type: API_TYPE.POST,
    },

    // 申请/加入班级
    JOIN_CLASS: {
        url: `/uapi/v1/class/member-join`,
        type: API_TYPE.POST,
    },
    // 同意/拒绝加入班级
    AGREE_JOIN_CLASS: {
        url: `/uapi/v1/class/member-agree-join`,
        type: API_TYPE.GET,
    },

    // 获取班级学员列表
    CLASS_JOIN_STUDENT: {
        url: `/uapi/v1/class/member-list`,
        type: API_TYPE.GET,
    },

    // 获取班级讲师列表
    CLASS_TEACHER: {
        url: `/uapi/v1/class/teacher-list`,
        type: API_TYPE.GET,
    },
    // 申请/加入班级
    CLASS_MEMBER_EXIT: {
        url: `/uapi/v1/class/member-exit`,
        type: API_TYPE.POST,
    },
    // 学员移除班级
    CLASS_MEMBER_BEEN_REMOVE: {
        url: `/uapi/v1/class/member-remove`,
        type: API_TYPE.GET,
    },
    // 班级空间 2018-09-18 20:42:04
    /**
     * 获取班级动态
     */
    CLASS_FEED_LIST: {
        url: `/uapi/v2/class/feed-list`,
        type: API_TYPE.GET,
    },

    /**
     * 发布通知
     */
    CLASS_SAVE_NOTICE: {
        url: `/uapi/v1/class/save-notice`,
        type: API_TYPE.POST,
    },

    /**
     * 删除通知
     */
    CLASS_DELETE_NOTICE: {
        url: `/uapi/v1/class/delete-notice`,
        type: API_TYPE.POST,
    },

    /**
     * 删除feed
     */
    CLASS_DELETE_FEED: {
        url: `/uapi/v1/class/delete-feed`,
        type: API_TYPE.POST,
    },

    /**
     * 班级动态置顶
     */
    CLASS_SET_TOP_FEED: {
        url: `/uapi/v1/class/top-feed`,
        type: API_TYPE.POST,
    },

    /**
     * 撤回班级学习任务
     */
    CLASS_REVOKE_TASK: {
        url: `/uapi/v1/learningtask/revoke-task`,
        type: API_TYPE.POST,
    },

    /**
     * 我创建的班级
     */
    CLASS_CREATE_LIST: {
        url: `/uapi/v1/class/create-list`,
        type: API_TYPE.GET,
    },

    /**
     * 我加入的班级
     */
    CLASS_JOIN_LIST: {
        url: `/uapi/v1/class/join-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取分享卡图片
     */
    SHARE_IMG: {
        url: `/uapi/v1/share/get-share-pic`,
        type: API_TYPE.GET,
    },

    SHARE_THEME_LIST: {
        url: `/uapi/v1/share/card-list`,
        type: API_TYPE.GET,
    },

    // 分享分享卡的埋点
    RECORD_SHARE_THEME: {
        url: `/uapi/v1/share/record`,
        type: API_TYPE.POST,
    },

    /**
     * 排行榜
     */
    CLASS_RANKINGS_LIST: {
        url: `/uapi/v1/class/task-completion-rank`,
        type: API_TYPE.GET,
    },

    /**
     * 获取班级管理员的学习任务列表
     */
    CLASS_ADMIN_TASK_LIST: {
        url: `/uapi/v1/class/task-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取班级学员的学习任务列表
     */
    CLASS_LEARNER_TASK_LIST: {
        url: `/uapi/v1/class/student-task-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取班级任务的完成列表
     */
    CLASS_TASK_COMPLETION_LIST: {
        url: `/uapi/v1/class/student-task-completion`,
        type: API_TYPE.GET,
    },

    /**
     * 分享到班级空间
     */
    SHARE_ON_CLASS_SAVE_SHARE: {
        url: `/uapi/v1/class/save-share`,
        type: API_TYPE.POST,
    },

    /* homework */
    GET_HOMEWORK_INFO: {
        url: '/uapi/v1/homework',
        type: API_TYPE.GET,
    },
    SUBMIT_SCORE: {
        url: '/uapi/v1/homework/score',
        type: API_TYPE.POST,
    },

    TIMELINE_STAT_LIST: {
        url: '/api/homework/getcommentstatlist',
        type: API_TYPE.GET,
    },

    TIMELINE_STAT_USER_LIST: {
        url: '/uapi/v1/homework/timeline-comment-students',
        type: API_TYPE.GET,
    },

    TIMELINE_COMMENT_LIST: {
        url: '/api/homework/gettimelinelist',
        type: API_TYPE.GET,
    },

    WEIKE_COMMENT_SUBMIT: {
        url: '/ajax/weikeCommentSubmit',
        type: API_TYPE.POST,
    },

    WEIKE_COMMENT_SUBMIT_NEW: {
        url: '/api/comment/weikeCommentSubmit',
        type: API_TYPE.POST,
    },

    /* 富文本 */
    SAVE_MULTIMEDIA: {
        url: '/api/multimedia/fulltextadd',
        type: API_TYPE.POST,
    },

    /* 富文本 update */
    UPDATE_MULTIMEDIA: {
        url: '/api/multimedia/fulltextupdcontent',
        type: API_TYPE.POST,
    },

    /* 图文内容列表 */
    IMAGE_TEXT_LIST: {
        url: '/api/multimedia/getimgtextlist',
        type: API_TYPE.GET,
    },

    IMAGE_TEXT_DEL: {
        url: '/api/multimedia/imgtextdel',
        type: API_TYPE.POST,
    },

    IMAGE_TEXT_UPLOAD: {
        url: '/api/multimedia/imgtextupd',
        type: API_TYPE.POST,
    },

    /* 内容类学习进度 */
    MAKE_DOC_READ_SPEED_STATUS: {
        url: '/api/session/makeweikestatus',
        type: API_TYPE.POST,
    },

    DOC_READ_SPEED_STATUS_RESET: {
        url: '/api/session/readreset',
        type: API_TYPE.GET,
    },

    /* 广告点击记录 */
    CLICK_ADD: {
        url: '/api/session/clickad',
        type: API_TYPE.GET,
    },

    // 课程下章节和小节列表
    SESSION_STATUS: {
        url: '/uapi/v1/exam/session-status',
        type: API_TYPE.GET,
    },
    // 课程下章节和小节列表
    COURSE_CHILDREN: {
        url: '/uapi/v2/element/list',
        type: API_TYPE.GET,
    },
    // 章节下小节列表
    CHAPTER_SESSION_LIST: {
        url: '/uapi/v2/element/chapter-session',
        type: API_TYPE.GET,
    },
    // 课程状态
    COURSE_CHAPTER_STATUS: {
        url: '/uapi/v1/chapter/completion-status',
        type: API_TYPE.GET,
    },

    /* 点赞 */
    PRISE_CREATOR: {
        url: '/ajax/weikeAppreciate',
        type: API_TYPE.POST,
    },

    /* 点赞-班级空间 */
    USER_LIKE: {
        url: '/uapi/v1/class/feed-like',
        type: API_TYPE.POST,
    },

    /* 点赞用户列表-班级空间 */
    USER_LIKE_LIST: {
        url: '/uapi/v1/class/feed-like-user',
        type: API_TYPE.GET,
    },

    /* 分词 */
    GET_FENCI: {
        url: '/uapi/v1/comment/fenci-list',
        type: API_TYPE.GET,
    },

    /* 正在听、已听完信息 */
    WEIKE_LISTENER_INFO: {
        url: '/ajax/getWeikeListenerInfo',
        type: API_TYPE.GET,
    },

    /**
     * @description 评论分享图片获取
     */
    GET_SHARE_PIC_URL: {
        url: '/uapi/v1/comment/get-share-pic-url',
        type: API_TYPE.GET,
    },

    /**
     * @description 评论提交
     */
    SAVE_COMMENT: {
        url: '/uapi/v1/comment/save',
        type: API_TYPE.POST,
    },

    /**
     * @description 评论提交 - 旧版接口
     */
    COMMENT_SUBMIT: {
        url: '/ajax/commentSubmit',
        type: API_TYPE.POST,
    },

    /**
     * @description 评论编辑
     */
    EDIT_COMMENT: {
        url: '/uapi/v1/comment/edit',
        type: API_TYPE.POST,
    },

    /**
     * @description 获取评论列表
     */
    GET_COMMENT_LIST: {
        url: '/uapi/v2/comment/list',
        type: API_TYPE.GET,
    },

    /**
     * @description 获取评论统计信息
     */
    GET_COMMENT_BANNER_INFO: {
        url: '/uapi/v2/comment/banner-info',
        type: API_TYPE.GET,
    },

    /**
     * @description 点赞
     */
    LIKE: {
        url: '/uapi/v1/like/save',
        type: API_TYPE.POST,
    },

    GET_HOMEWORK_LIST: {
        url: '/uapi/v1/homework/list',
        type: API_TYPE.GET,
    },
    GET_HOMEWORKS_STAT: {
        url: `${v1}/homework/feedback-info`,
        type: API_TYPE.GET,
    },
    DELETE_HOMEWORK_FEEDBACK: {
        url: `${v1}/homework/graffiti-feedback-delete`,
        type: API_TYPE.POST,
    },

    /**
     * 获取资源列表
     */
    GET_RESOURCE_LIST: {
        url: '/uapi/v1/resource/document-list',
        type: API_TYPE.GET,
    },

    GET_RESOURCE_ARR: {
        url: '/ajax/resource/getresourcelist',
        type: API_TYPE.GET,
    },
    /**
     * 绑定资源
     */
    RESOURCE_BIND_UPD: {
        url: '/uapi/v1/resource/bind-upd',
        type: API_TYPE.POST,
    },
    RESOURCE_BIND_UPD_V2: {
        url: '/uapi/v2/resource/bind-upd',
        type: API_TYPE.POST,
    },

    /**
     * 获取转码后的资源信息，音视频
     * https://dev18.umucdn.cn/uapi/v1/resource/info?resource_id=300000161&resource_type=1
     */
    GET_RESOURCE_INFO: {
        url: '/uapi/v1/resource/info',
        type: API_TYPE.GET,
    },
    /**
     * 保存资源
     */
    SAVE_RESOURCE: {
        url: '/uapi/v1/resource/save',
        type: API_TYPE.POST,
    },

    /**
     * 提交作业
     */
    HOMEWORK_SAVE: {
        url: '/uapi/v1/homework/save',
        type: API_TYPE.POST,
    },

    /**
     * 删除作业
     */
    HOMEWORK_DELETE: {
        url: '/uapi/v1/homework/delete',
        type: API_TYPE.POST,
    },

    /**
     * 下载作业
     */
    HOMEWORK_DOWNLOAD: {
        url: '/uapi/v1/homework/download',
        type: API_TYPE.GET,
    },

    /**
     * 获取问卷
     */
    POLL_GET: {
        url: `${POLL_API}/get`,
        type: API_TYPE.GET,
    },

    /**
     *  提交问卷
     */
    POLL_SUBMIT: {
        url: `${POLL_API}/submit`,
        type: API_TYPE.POST,
    },

    QUESTIONAIRE_SUBMIT: {
        url: '/ajax/bulkCommentSubmit',
        type: API_TYPE.POST,
    },

    /**
     * 获取学员列表
     */
    POLL_USER_LIST: {
        url: `${POLL_API}/user-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取单个学员问卷提交信息
     */
    POLL_USER_RESULT: {
        url: `${POLL_API}/user-result`,
        type: API_TYPE.GET,
    },

    /**
     *  问卷结果统计
     */
    POLL_RESULT_STAT: {
        url: `${POLL_API}/result-stat`,
        type: API_TYPE.GET,
    },

    /**
     *  问卷文本类题目（开放式问题或带“其他”选项的选择题）详情
     */
    POLL_QUESTION_CONTENT_LIST: {
        url: `${POLL_API}/question-content-list`,
        type: API_TYPE.GET,
    },

    // 课程排行榜
    GET_COURSE_POINTS_RANK: {
        url: `/api/points/getpointsrank`,
        type: API_TYPE.GET,
    },

    GET_COURSE_MY_POINTS_RANK: {
        url: `/api/points/getmypointsrank`,
        type: API_TYPE.GET,
    },

    GET_COURSE_RANK_SHARE_PIC: {
        url: `/api/share/getgroupranksharepic`,
        type: API_TYPE.GET,
    },
    /**
     *  保存学习证书模板
     */
    COURSE_SAVE_CERTIFICATE_THEME: {
        url: `${COURSE_API}/save-certificate`,
        type: API_TYPE.POST,
    },
    /**
     * @desc 保存学习项目学习证书
     * https://yapi.umu.work/project/121/interface/api/14388
    */
    PROGRAM_SAVE_CERTIFICATE_THEME: {
        url: '/uapi/v1/program/save-certificate',
        type: API_TYPE.POST,
    },
    /**
     *  展示学习证书
     */
    COURSE_SHOW_CERTIFICATE_DIALOG: {
        url: `${COURSE_API}/show-dialog`,
        type: API_TYPE.GET,
    },

    /* 迁移 用户成就，获取未展示的弹窗*/
    ACHIEVEMENT_GET_UNREAD_DIALOGS: {
        url: `/api/up/getunreaddialogs`,
        type: API_TYPE.GET,
    },

    /* 迁移 用户成就，设置已经展示的弹窗*/
    ACHIEVEMENT_READ_DIALOG: {
        url: `/api/up/readdialog`,
        type: API_TYPE.POST,
    },
    /* 埋点日志 */
    STAT_LOG_DIALOG: {
        url: `/uapi/v1/stat/log`,
        type: API_TYPE.POST,
    },
    CREATE_IMG: {
        url: '/napi/media/screenshot',
        type: API_TYPE.GET,
    },

    GET_WX_JS_CONFIG: {
        url: '/uapi/v1/config/wx-js-config',
        type: API_TYPE.GET,
    },

    // https://wiki.umu.work/pages/viewpage.action?pageId=21889570
    GET_WX_JS_CONFIG_WXWORK: {
        url: '/uapi/v1/config/context-info',
        type: API_TYPE.GET,
    },

    // https://wiki.umu.work/pages/viewpage.action?pageId=21889570
    GET_MEDIA_URL: {
        url: `${v1}/workwx/get-media-url`,
        type: API_TYPE.GET,
    },
    GET_WX_INFO: {
        url: `${v1}/wx/follow-us`,
        type: API_TYPE.GET,
    },
    GET_SIBLINGS_NAV: {
        url: `/napi/element/get-siblings-nav`,
        type: API_TYPE.GET,
    },

    GET_NEXT_URL: {
        url: `${v1}/element/adjacent-element`,
        type: API_TYPE.GET,
    },

    GET_USER_INFO: {
        url: '/uapi/v1/user/get',
        type: API_TYPE.GET,
    },

    GET_SYS_CONFIG: {
        url: '/uapi/v1/config/sys-config',
        type: API_TYPE.GET,
    },

    UPDATE_USER_SETUP: {
        url: '/api/user/updatesetup',
        type: API_TYPE.POST,
    },

    GET_UNREAD_MESSAGE_COUNT: {
        url: '/uapi/v1/message/get-unread-count',
        type: API_TYPE.GET,
    },

    /**
     * 获取学习项目我的的积分
     * http://api.umucdn.cn/project/151/interface/api/2045
     */
    GET_PROGRAM_MY_RANK: {
        url: '/uapi/v1/program/get-student-points-rank',
        type: API_TYPE.GET,
    },

    /**
     * 获取学习项目积分列表
     * http://api.umucdn.cn/project/151/interface/api/2045
     */
    GET_PROGRAM_RANK_LIST: {
        url: '/uapi/v1/program/get-student-points-info',
        type: API_TYPE.GET,
    },

    GET_HOMEWORK_SEARCH_SUGGEST: {
        url: '/uapi/v1/homework/homework-search',
        type: API_TYPE.GET,
    },

    GET_HOMEWORK_FEEDBACK_LIST: {
        url: '/uapi/v1/homework/feedback-list',
        type: API_TYPE.GET,
    },
    GET_HOMEWORK_FEEDBACK_DETAIL: {
        url: '/uapi/v1/homework/graffiti-feedback-get',
        type: API_TYPE.GET,
    },

    /**
     * 拍照优化
     * http://api.umucdn.cn/project/166/interface/api/2279
     */

    /* 获取图片上传者列表 */
    PHOTO_GET_PHOTO_AUTHOR_LIST: {
        url: '/uapi/v1/photo/authors',
        type: API_TYPE.GET,
    },

    /* 保存图片 */
    PHOTO_UPLOAD_PHOTO: {
        url: '/uapi/v1/photo/save',
        type: API_TYPE.POST,
    },

    /* 获取图片列表 */
    PHOTO_GET_PHOTOS: {
        url: '/uapi/v1/photo/list',
        type: API_TYPE.GET,
    },

    /* 获取图片列表 */
    PHOTO_GET_PHOTOS_BY_USER: {
        url: '/uapi/v1/photo/list-by-user',
        type: API_TYPE.GET,
    },

    /* 获取图片的点赞列表 */
    PHOTO_GET_LIKE_USER_LIST: {
        url: '/uapi/v1/photo/like-detail',
        type: API_TYPE.GET,
    },

    /* 点赞 or 取消点赞 */
    PHOTO_LIKE_PHOTO: {
        url: '/uapi/v1/photo/like',
        type: API_TYPE.POST,
    },

    /* 图片列表的默认设计 */
    PHOTO_SAVE_PHOTO_LIST_SETTING: {
        url: '/uapi/v1/photo/save-setting',
        type: API_TYPE.POST,
    },

    /* 置顶/删除／屏蔽 */
    PHOTO_SET_PHOTO: {
        url: '/uapi/v1/photo/set',
        type: API_TYPE.POST,
    },
    /* 拍照查看次数打点 */
    PHOTO_SET_COUNT: {
        url: '/uapi/v1/photo/count',
        type: API_TYPE.GET,
    },

    /* 统计数据 */
    PHOTO_GET_ANALYSE_INFO: {
        url: '/uapi/v1/photo/number',
        type: API_TYPE.GET,
    },
    // 加油包特权列表
    GET_PRIVILEGE_LIST: {
        url: '/uapi/v1/influence/privilege-list',
        type: API_TYPE.GET,
    },
    // 加油包助力列表
    GET_BOOST_LIST: {
        url: '/uapi/v1/influence/boost-list',
        type: API_TYPE.GET,
    },
    // 加油包特权兑换记录
    GET_REDEMPTION_RECORD: {
        url: '/uapi/v1/influence/privilege-record',
        type: API_TYPE.GET,
    },
    // 加油包特权兑换
    EXCHANGE_PRIVILEGE: {
        url: '/uapi/v1/influence/exchange-privilege',
        type: API_TYPE.POST,
    },
    // 助力
    INFLUENCE_BOOST: {
        url: '/uapi/v1/influence/boost',
        type: API_TYPE.POST,
    },

    // 加油包邀请历史
    GET_INVITE_HISTORY: {
        url: '/uapi/v1/user/invite-list',
        type: API_TYPE.GET,
    },
    // 获取问卷列表
    GET_SURVEY_LIST: {
        url: '/uapi/v1/poll/question-list',
        type: API_TYPE.GET,
    },
    // 问卷保存 answer
    SAVE_SURVEY: {
        url: '/megrez/poll/v1/save-poll-result',
        type: API_TYPE.POST,
    },
    SAVE_SURVEY_DRAFT: {
        url: '/megrez/poll/v1/user-save-poll-result',
        type: API_TYPE.POST,
    },
    SUBMIT_SURVEY: {
        url: '/megrez/poll/v1/user-submit-poll',
        type: API_TYPE.POST,
    },
    // 获取某个用户的回答
    GET_USER_RESULT: {
        url: '/uapi/v1/poll/get-user-result',
        type: API_TYPE.GET,
    },
    // 获取某个用户问卷的统计
    GET_USER_RESULT_SUMMARY: {
        url: '/uapi/v1/poll/user-result-summary',
        type: API_TYPE.GET,
    },
    // 获取问题 id 与 type 的映射
    GET_SECTION_MAP: {
        url: '/uapi/v1/poll/question-type',
        type: API_TYPE.GET,
    },
    // 问卷访问人数打点
    SURVEY_VIEW_COUNTER: {
        url: '/uapi/v1/poll/view-counter',
        type: API_TYPE.GET,
    },
    // 获取问卷提交历史
    GET_SURVVEY_SUBMIT_LIST: {
        url: '/uapi/v1/poll/submit-list',
        type: API_TYPE.GET,
    },
    // 评论删除
    COMMENT_DELETE: {
        url: '/uapi/v1/comment/delete',
        type: API_TYPE.POST,
    },

    // 评论置顶
    COMMENT_TOP: {
        url: '/uapi/v1/comment/top',
        type: API_TYPE.POST,
    },

    // 评论屏蔽和审核状态更新
    COMMENT_SET_STATUS: {
        url: '/uapi/v1/comment/set-status',
        type: API_TYPE.POST,
    },

    // 更新 setup 属性
    UPDATE_SETUP: {
        url: '/uapi/v1/setup/save',
        type: API_TYPE.POST,
    },

    // 添加收藏
    ADD_COLLECTION: {
        url: '/uapi/v1/collections/add',
        type: API_TYPE.POST,
    },

    // 取消收藏
    CANCEL_COLLECTION: {
        url: '/uapi/v1/collections/cancel',
        type: API_TYPE.POST,
    },
    // 判断对象是否收藏
    IS_COLLECTED: {
        url: '/uapi/v1/collections/is-collected',
        type: API_TYPE.GET,
    },
    // 判断对象是否收藏(批量)
    IS_COLLECTED_MULTI: {
        url: '/uapi/v1/collections/is-collected-multi',
        type: API_TYPE.POST,
    },
    // 启动ppt2img转换任务
    PPT_TO_IMG: {
        url: '/nwapi/resource/ppt-to-img',
        type: API_TYPE.POST,
    },

    // 轮询ppt2img转换任务状态
    PPT_TO_IMG_STATUS: {
        url: '/nwapi/resource/ppt-to-img-status',
        type: API_TYPE.GET,
    },

    // 取消转换任务状态
    PPT_TO_IMG_CANCEL: {
        url: '/nwapi/resource/cancel-ppt-to-img',
        type: API_TYPE.POST,
    },

    // 保存文档小节最新查看页数
    UPDATE_DOCUMENT_VIEW_PAGE_NUM: {
        url: '/uapi/v1/element/set-weike-pages',
        type: API_TYPE.POST,
    },

    // 获取文档小节最新查看页数
    GET_DOCUMENT_VIEW_PAGE_NUM: {
        url: '/uapi/v1/element/get-weike-pages',
        type: API_TYPE.GET,
    },

    // 检查提问讨论评论版本
    GET_COMMENT_VERSION: {
        url: '/ajax/hasUnloaded',
        type: API_TYPE.POST,
    },

    // 获取收藏列表
    GET_FAVORITE_LIST: {
        url: '/uapi/v1/collections/list',
        type: API_TYPE.GET,
    },
    // 获取下一个 element
    GET_NEXT_ELEMENT: {
        url: '/uapi/v1/element/get-next',
        type: API_TYPE.GET,
    },

    // 获取收藏列表
    ADD_QUESTION_COLLECTION_UAPI: {
        url: '/uapi/v1/exam/question-collection-add',
        type: API_TYPE.GET,
    },

    /**
     * 首页课程分类
     */
    GET_TOP_LEVEL_CATEGORY: {
        url: '/uapi/v1/enterprise/top-level-category',
        type: API_TYPE.GET,
    },

    /**
     * 首页配置
     */
    GET_HOME_PAGE_INFO: {
        url: '/api/homepage/gethomepageinfo',
        type: API_TYPE.GET,
    },

    /**
     * 获取我的学习任务列表
     */
    GET_MY_TASKS: {
        url: '/api/task/myassignmentlist',
        type: API_TYPE.GET,
    },

    /**
     * 推荐打点
     */
    RECOMMEND_RECORD: {
        url: '/api/recommend/record',
        type: API_TYPE.POST,
    },

    /**
     * 首页排行榜
     */
    GET_LEARNER_LIST: {
        url: '/api/enterprise/getlearnerlist',
        type: API_TYPE.GET,
    },

    /**
     * 首页自定义文字
     */
    GET_HOME_CUSTOM_TEXT: {
        url: '/uapi/v1/enterprise/get-index-content',
        type: API_TYPE.GET,
    },

    /**
     * 分配权限
     */
    UPDATE_ACCESS_ASSIGN: {
        url: `/api/manage/updateaccessuser`,
        type: API_TYPE.POST,
    },

    /**
     * 用户搜索
     */
    ACCOOUNT_SEARCH: {
        url: '/api/manage/accessaccountmatch',
        type: API_TYPE.GET,
    },

    /**
     * 已分配权限列表
     */
    ACCESS_ASSIGN_LIST: {
        url: `/api/manage/getcourseaccesslist`,
        type: API_TYPE.GET,
    },

    GET_RESOURCE_LIST_V2: {
        url: `${v2}/resource/list`,
        type: API_TYPE.GET,
    },

    DO_PLAYING_MARK: {
        url: `${v1}/playableEntity/play`,
        type: API_TYPE.GET,
    },

    /**
     * @description 考试，问卷，作业提交时间设置 相关接口
     * @interface https://wiki.umu.work/pages/viewpage.action?pageId=27597211
     */
    GET_PARTICIPATE_STATUS: {
        url: `${v1}/session/participate-status`,
        type: API_TYPE.GET,
    },
    GET_ELEMENT_SETUP: {
        url: `${v1}/setup/get`,
        type: API_TYPE.GET,
    },
    IS_COOPERATOR: {
        url: `${v1}/user/is-teacher`,
        type: API_TYPE.GET,
    },
    SET_MESSAGE_STATUS: {
        url: `/api/message/setmessagestatus`,
        type: API_TYPE.GET,
    },
    REJECT_JOIN_ENTERPRISE: {
        url: `/uapi/v1/user/reject-join-enterprise`,
        type: API_TYPE.GET,
    },
    READ_DIALOG: {
        url: `/api/up/readdialog`,
        type: API_TYPE.POST,
    },
    DOACTIVATE: {
        url: `/api/enterprise/doactivate`,
        type: API_TYPE.POST,
    },
	NAPI_HTML_TO_PIC: {
		url: '/napi/resource/migrate/html-to-pic',
		type: API_TYPE.GET,
	},
	NAPI_HTML_TO_PIC_STATUS: {
		url: '/napi/resource/html-to-pic-status',
		type: API_TYPE.GET,
	},
	NAPI_GET_CONFIG: {
		url: '/napi/config/center',
		type: API_TYPE.GET,
	},
	GET_RICH_TEXT_CONZTENZT: {
		url: '/ajax/multimedia/fulltextinfo',
		type: API_TYPE.GET,
	},
    ADD_RICH_TEXT_CONZTENZT: {
		url: '/ajax/multimedia/fulltextadd',
		type: API_TYPE.POST,
	},
	UPDATE_RICH_TEXT_CONZTENZT: {
		url: '/ajax/multimedia/fulltextupdcontent',
		type: API_TYPE.POST,
	},
};

/**
 * 下载表格
 */
const OUTPUT_REPORT = {
    url: '/api/report/output',
    type: API_TYPE.GET,
};

const API: IUnclearKeyObj<IApi> = {
    ...CommonApi,
    ...PaymentAPI,
    ...QuestionCollectionAPI,
    ...NodejsExamAPI,
    ...PrivateMessageAPI,
    ...EnterpriseAPI,
    ...DepartmentAPI,
    ...ProfileAPI,
    ...SearchAPI,
    ...ReportAPI,
    ...MarketAPI,
    ...AuthAPI,
    ...CategoryAPI,
    ...SubTitleAPI,
    ...HomeworkAPI,
    ...GrowthApi,
    ...CourseAPI,
    ...UShowApi,
    OUTPUT_REPORT,
};

export default API;
